module.exports = __webpack_public_path__ + "static/dummy-pdf-8eeacddc276f5ee13a7ddf8f6399f193.pdf";